export default ({ attributes }) => {
  const {
    text,
    buttonHref,
    variant,
    size,
    image,
    iconPosition,
    hideOnMobile,
    hideOnDesktop,
    margin,
    buttonTarget,
    align,
    target,
  } = attributes;
  return (
    <a
      className={`
        Button
        ${variant} ${size}
        ${hideOnDesktop ? 'hide-desktop' : ''}
        ${hideOnMobile ? 'hide-mobile' : ''}
        ${variant == 'withIcon' ? iconPosition : ''}
        ${margin} ${align} ${target ? 'ModalForm-open' : ''}
      `}
      href={buttonHref}
      {...(buttonTarget && { target: '_blank' })}
    >
      {text}
      {variant == 'withIcon' && (
        <figure>
          <img
            src={image.src}
            title={image.alt}
            width={image.width}
            height={image.height}
            alt={image.alt}
          />
        </figure>
      )}
    </a>
  );
};
